import { addMinutes, startOfToday } from "date-fns";
import { getUnicode } from "emoji-dictionary";
import { map, range } from "lodash-es";

export function formatEnumKey(key: string): string {
  return key.replace(/([a-z])([A-Z])/g, "$1 $2");
}

export const getValidRescheduleTimes = () => {
  const date = startOfToday().setHours(19);
  const intervalMinutes = 15;
  const intervalCount = (5 * 60) / intervalMinutes;
  return map(range(intervalCount), (i) => {
    return addMinutes(date, i * intervalMinutes);
  });
};

export const dateString = (date: Date): string => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
};

export const urlify = (text: string) =>
  text.replace(
    /(https?:\/\/[^\s]+)/g,
    (url) => '<a target="_blank" href="' + url + '">' + url + "</a>"
  );

export const convertEmojisToIcons = (message: string): string => {
  const customMappings: Record<string, string> = {
    ":D": "😃",
    ":)": "🙂",
  };

  const regex = /(:\w+:)|(:\)|:D)/g;
  const convertedMessage = message.replace(regex, (match) => {
    const emojiUnicode = getUnicode(match);
    if (emojiUnicode) {
      return emojiUnicode;
    } else if (Object.prototype.hasOwnProperty.call(customMappings, match)) {
      return customMappings[match];
    } else {
      return match;
    }
  });

  return convertedMessage;
};
